import React, { PureComponent, Fragment } from 'react';
import { Query } from 'react-apollo';
import * as constants from 'common/constants';
import { FETCH_ALL_CONTRACTS } from 'api/contract';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  CardList,
  IconList,
  Modal,
  ProgressBar,
  Offline,
  BannerComponent,
} from 'common/components';
import { date } from 'common/formatters';
import { base64url_encode } from 'util/base64';
import { offline as OfflineIcon } from 'common/svg/icons';
import { withApollo } from 'react-apollo';
import { compose } from 'redux';
import { FETCH_CONTRACT } from 'api/contract';

export class ContractList extends PureComponent {
  static displayName = 'ContractList';

  static propTypes = {
    client: PropTypes.object.isRequired,
    season: PropTypes.number,
  };

  constructor() {
    super();
    this.state = {
      showUnavailableModal: false,
    };
  }

  hideUnavailableModal = () => {
    this.setState({
      showUnavailableModal: false,
    });
  };

  showUnavailableModal = () => {
    this.setState({
      showUnavailableModal: true,
    });
  };

  render() {
    return (
      <Query
        query={FETCH_ALL_CONTRACTS}
        fetchPolicy="cache-and-network"
        variables={{ season: this.props.season, active: true }}
      >
        {({ loading, error, data }) => {
          if (loading || error) return null; // handle side effects here in the future.
          const { getAllContracts } = data;
          const sortedContracts = this._getSortedContracts(getAllContracts);

          return (
            <Fragment>
              <Offline>
                <BannerComponent
                  message="Some contracts may not be available in offline mode."
                  theme={['offline-short']}
                  leftIcon={<OfflineIcon />}
                />
              </Offline>
              <CardList
                cards={this._getCardsArray(sortedContracts)}
                emptyStateconfig={{
                  message:
                    'Add contracts to track deliveries and see forecasted revenue on the dashboard.',
                  btnMessage: 'Add Contract',
                  routeName: constants.ROUTE_CONTRACTS_ADD,
                }}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }

  _getCardsArray = data => data.map(contract => this._getCardData(contract));

  _getCardData = contract => {
    const { client } = this.props;

    let availableOffline = false;
    try {
      client.readQuery({
        query: FETCH_CONTRACT,
        variables: { id: contract.id },
      });
      availableOffline = true;
    } catch (error) {
      // Apollo throws an error if no data is found
    }

    return {
      availableOffline,
      handleUnavailableClick: this.showUnavailableModal,
      title: contract.company,
      content: this._getContent(contract),
      link: `${constants.ROUTE_CONTRACTS_DETAIL}/${base64url_encode(
        contract.id.trim()
      )}`,
    };
  };

  _getContent = contract => {
    const { crop, quantity, deliveryDate } = contract;
    const { delivered, pending, contracted } = quantity;
    const cropType = (delivered && delivered.type) || (pending && pending.type);
    const productAmountLabel = `${Number(delivered.size) +
      Number(pending.size)} ${cropType}`;
    const cropLabel = `${crop.name} ${crop.variety ? crop.variety : ''}`;
    const progressBarLabels = {
      used: 'Delivered',
      free: 'Pending',
    };

    const formattedDate = deliveryDate ? date(deliveryDate) : null;
    const list = [];

    crop &&
      list.push({
        icon: 'crop',
        label: cropLabel,
      });

    delivered &&
      pending &&
      list.push({
        icon: 'storagefill',
        label: productAmountLabel,
      });

    date &&
      list.push({
        icon: 'calendar',
        label: formattedDate,
      });

    return (
      <Fragment>
        <IconList list={list} />
        <ProgressBar
          label={progressBarLabels}
          value={delivered.size}
          max={contracted.size}
          unit={cropType.slice(0, 2)}
        />
        {this.state.showUnavailableModal && (
          <Modal
            header={'Unavailable offline'}
            theme={['narrow']}
            onToggle={this.hideUnavailableModal}
          >
            <p>You must be connected to the internet to view this contract.</p>
            <section className={'field__group'}>
              <fieldset className={'field text--center'}>
                <Button
                  className="btn btn--primary"
                  onClick={this.hideUnavailableModal}
                >
                  OK
                </Button>
              </fieldset>
            </section>
          </Modal>
        )}
      </Fragment>
    );
  };

  _getSortedContracts = (contracts = []) => {
    const copiedArray = contracts.slice(0);
    return copiedArray.sort((a, b) =>
      a.company.toLowerCase().localeCompare(b.company.toLowerCase())
    );
  };
}

const mapState = ({ settings }) => {
  return { season: settings.season };
};

export default compose(
  connect(mapState),
  withApollo
)(ContractList);



// WEBPACK FOOTER //
// ./src/containers/ContractList/index.js